import React from "react";
import { useSelector } from "react-redux";
import { getChats } from "../../api/chat/chat";
import { RootState } from "../../store/store";
import { Chat } from "../../api/chat/chat-interface";
import { useDispatch } from "react-redux";
import { setChats } from "../../store/chatSlice/chatSlice";


type UserType = "student" | "teacher" | "parent";

const userTypeToKeyMap: Record<UserType, string> = {
  student: "Students",
  teacher: "Teachers",
  parent: "Parents",
};

type ChatRooms = {
  Students: Chat[];
  Parents: Chat[];
  Teachers: Chat[];
};

const useChats = () => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = React.useState(false);
  const { user } = useSelector((state: RootState) => state.user);

  const fetchChatRooms = async () => {
    try {
      setIsLoading(true);
      const response = await getChats();
      dispatch(setChats(sortPrivateChats(response.data.data.docs, user?._id)));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    fetchChatRooms();
  }, []);

 
  return {
    isLoading,
  };
};

export default useChats;

function sortPrivateChats(chats: Chat[], userId: string): ChatRooms {
  const sortedChats: ChatRooms = {
    Students: [],
    Parents: [],
    Teachers: [],
  };

  chats.forEach((chat) => {
    if (chat.members.length !== 2) return;

    const receiver = chat.members.find(
      (member) =>
        member?.userId &&
        member?.userId?._id !== userId &&
        member.memberType === "user"
    );

    if (!receiver || !receiver.userId?.userType) return;

    const userType = receiver.userId.userType;
    if (userType in userTypeToKeyMap) {
      if (userType in userTypeToKeyMap) {
        (
          sortedChats[
            userTypeToKeyMap[userType as UserType] as keyof ChatRooms
          ] as Chat[]
        ).push(chat);
      }
    }
  });

  return sortedChats;
}

